import { GET_SHARED_MEDIA, GetSharedMediaApi } from '@weblite-wapps/protocol'
import * as SharedMediaService from '$logic/shared-media/service'
import { wappSubscription } from '$logic/wapp-communication/helper/subscription-handler'

wappSubscription.subscribe<GetSharedMediaApi>(GET_SHARED_MEDIA, payload => {
  return SharedMediaService.getSharedMediaByIid(
    payload.roomId,
    payload.categories,
    payload.pageToken,
  )
})
